<form [formGroup]='fixedInterestPayRecForm'>
    <div class="row">
        <div class="col-lg-3 form-group">
            <label>Fixed Rate<span class="red">*</span> </label>
            <input type="text" class="form-control form-control-sm" formControlName="fixedRate" (change)="onSubmit()">
            <p *ngIf="f.fixedRate.invalid && f.fixedRate.touched" class="error nocase">
                Please enter Fixed Rate
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <legend class="mt-2">Backward Effective Flag <span class="red">*</span></legend>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="backwrdEffDateFlg" name="backwrdEffDateFlg" value="Y"
                    class="form-check-input" (change)="onSubmit()"
                    [ngClass]="{'is-invalid': (f.backwrdEffDateFlg.touched) && f.backwrdEffDateFlg.errors}">
                <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="backwrdEffDateFlg" name="backwrdEffDateFlg" value="N"
                    class="form-check-input" (change)="onSubmit()"
                    [ngClass]="{'is-invalid': (f.backwrdEffDateFlg.touched) && f.backwrdEffDateFlg.errors}">
                <label class="form-check-label">No</label>
            </div>
            <p *ngIf="f.backwrdEffDateFlg.invalid && f.backwrdEffDateFlg.touched" class="error">
                Enter select Backward Effective Flag
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Effective Date<span class="red">*</span></label>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm datepicker" formControlName="effectiveDate"
                    bsDatepicker [bsConfig]="{ isAnimated: true}" placeholder="Select Effective Date"
                    [(bsValue)]="bsValue[0]" (ngModelChange)="onSubmit();getPaymentSchedule()">
                <div class="input-group-append pointer">
                    <span class="input-group-text">
                        <i class="fa fa-calendar" bsDatepicker [bsConfig]="{ isAnimated: true }"
                            [ngClass]="f.effectiveDate.disabled?'disabled':''" [(bsValue)]="bsValue[0]"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3 form-group">
            <legend class="mt-2">Recouponing Flag <span class="red">*</span></legend>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="recouponingFlag" name="recouponingFlag" value="Y"
                    class="form-check-input" (change)="onSubmit()"
                    [ngClass]="{'is-invalid': (f.recouponingFlag.touched) && f.recouponingFlag.errors}">
                <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="recouponingFlag" name="recouponingFlag" value="N"
                    class="form-check-input" (change)="onSubmit()"
                    [ngClass]="{'is-invalid': (f.recouponingFlag.touched) && f.recouponingFlag.errors}">
                <label class="form-check-label">No</label>
            </div>
            <p *ngIf="f.recouponingFlag.invalid && f.recouponingFlag.touched" class="error">
                Please select Recouponing Flag
            </p>
        </div>
        <div class="col-lg-3 form-group" *ngIf="f.recouponingFlag.value=='Y'">
            <label>No of Repetitions (Recouponing)<span class="red">*</span> </label>
            <input type="text" class="form-control form-control-sm" formControlName="recouponingRepetitions"
                (change)="onSubmit();getRecouponingSchedule()" [required]="f.recouponingFlag.value=='Y'">
            <p *ngIf="f.recouponingRepetitions.invalid && f.recouponingRepetitions.touched" class="error nocase">
                Please enter No of Repetitions for Recouponing
            </p>
        </div>
        <div class="col-lg-6 mt-3" *ngIf="f.recouponingFlag.value=='Y'">
            <a class="btn btn-link nocase" data-toggle="modal" data-target="#recouponingDtls">
                <h4>Click here to input details of Recouponing </h4>
            </a>
        </div>
        <div class="col-lg-3 form-group">
            <legend class="mt-2">Stub <span class="red">*</span></legend>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="stub" name="stub" value="Y" class="form-check-input"
                    [ngClass]="{'is-invalid': (f.stub.touched) && f.stub.errors}" (change)="onSubmit();stubChange()">
                <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="stub" name="stub" value="N" class="form-check-input"
                    [ngClass]="{'is-invalid': (f.stub.touched) && f.stub.errors}" (change)="onSubmit();stubChange()">
                <label class="form-check-label">No</label>
            </div>
            <p *ngIf="f.stub.invalid && f.stub.touched" class="error">
                Please select Stub
            </p>
        </div>
        <div class="col-lg-3 form-group" *ngIf="f.stub.value=='Y'">
            <label>First Payment Date<span class="red">*</span></label>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm datepicker" formControlName="firstPaymentDate"
                    bsDatepicker [bsConfig]="{ isAnimated: true}" [(bsValue)]="bsValue[1]"
                    placeholder="Select First Payment Date">
                <div class="input-group-append pointer">
                    <span class="input-group-text">
                        <i class="fa fa-calendar" bsDatepicker [bsConfig]="{ isAnimated: true }"
                            [ngClass]="f.firstPaymentDate.disabled?'disabled':''" [(bsValue)]="bsValue[1]"></i>
                    </span>
                </div>
            </div>
            <p *ngIf="f.firstPaymentDate.invalid && f.firstPaymentDate.touched" class="error">
                Please select First Payment Date
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Day Count Fraction<span class="red">*</span></label>
            <select class="form-control form-control-sm selectpicker" formControlName="dayCntFrctn"
                title="Select Day Count Fraction" data-live-search="true" (change)="onSubmit()">
                <option *ngFor="let data of dayCountFractionList" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="f.dayCntFrctn.invalid && f.dayCntFrctn.touched" class="error">
                Please select Day Count Fraction
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>No. Of Repetition<span class="red">*</span></label>
            <input type="text" class="form-control form-control-sm" formControlName="noOfRepetition"
                (change)="onSubmit();getPaymentSchedule()">
        </div>
        <div class="col-lg-3 form-group">
            <label>Payment Frequency<span class="red">*</span></label>
            <select class="form-control form-control-sm selectpicker" formControlName="paymentFreqncy"
                title="Select Payment Frequency" data-live-search="true" (change)="onSubmit();getPaymentSchedule()">
                <option *ngFor="let data of paymentFreqList" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="f.paymentFreqncy.invalid && f.paymentFreqncy.touched" class="error nocase">
                Please select Payment Frequency
            </p>
        </div>
    </div>
    <div class="row mt-2 mb-2">
        <div class="col-lg-6">
            <a class="btn btn-link nocase" data-toggle="modal" attr.data-target="{{'#'+fixedInterestFormGroupName}}">
                <h4>Click here to input Payment Dates </h4>
            </a>
        </div>
    </div>
    <div class="modal fade" attr.id="{{fixedInterestFormGroupName}}" tabindex="-1" role="dialog"
        aria-labelledby="fixedPaymentModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header card-header">
                    <h5 class="modal-title">Input Payment Dates</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <app-amrt-acrt-schedule formType="fixedPaymentSchedule" [irsFormData]="paymentData"
                        [action]="action" (formUpdate)="formUpdate($event)"></app-amrt-acrt-schedule>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Save Changes </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="recouponingDtls" tabindex="-1" role="dialog" aria-labelledby="recouponingDtlsModalTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header card-header">
                    <h5 class="modal-title">Recouponing Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <app-amrt-acrt-schedule formType="recouponingDtls" [irsFormData]="recouponingDtls" [action]="action"
                        (formUpdate)="recouponFormUpdate($event)"></app-amrt-acrt-schedule>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Save Changes </button>
                </div>
            </div>
        </div>
    </div>
</form>